<template>
  <div>
    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(formSubmit)">
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              type="text"
              v-model="model.title"
              :label="$t('Block title')"
              :name="$t('Block title')"
              labelClasses="required form-control-label"
              rules="required|max:250"
            >
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              :label="$t('Description')"
              :name="$t('Description')">
              <textarea
                v-model="model.description"
                class="form-control"
                rows="3"></textarea>
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <base-checkbox class="mb-3" v-model="model.isVisible">
              {{ $t('Show status') }}
            </base-checkbox>
          </div>
        </div>
        <base-button
          :loading="loading"
          type="primary"
          native-type="submit">
          {{ $t('Create block') }}
        </base-button>
      </form>
    </validation-observer>
  </div>
</template>


<script>
  import {BlockForm} from "../../../mixins/Block/BlockForm";
  import {FormSubmitHandlers, FormNotification} from "../../../mixins/FormApiHandlers";

  import {createNamespacedHelpers} from 'vuex';
  const {mapActions, mapState} = createNamespacedHelpers('course/block');

  export default {
    name: "FormCreateBlock",
    mixins: [BlockForm, FormNotification, FormSubmitHandlers],
    data() {
      return {
        successMessage: this.$i18n.t('New course block created success!'),
        errorMessage: this.$i18n.t('Error on creating new block!'),
        submitRedirectTo: {name: 'content', params: this.$route.params}
      }
    },
    computed: {
      ...mapState({
        status: state => state.createStatus.status
      })
    },
    methods: {
      ...mapActions({
        createBlock: 'createBlock',
        revertStatus: 'revertCreateStatus',
      }),
      formSubmit() {
        this.createBlock({
          urlParams: this.$route.params,
          form: this.model
        });
      }
    }
  }
</script>
